import React from 'react'
import { Form } from 'react-bootstrap'
import { AnnotationDataBoundingBox } from '../../../types/models/annotation'
import AALReviewSnippetCard from './AALReviewSnippetCard'

interface AALReviewSnippetGridProps {
  items: AnnotationDataBoundingBox[]
  contentId: string
  selectedBBoxClassIndex?: number
  showConfidence?: boolean
  showAcceptButton?: boolean
  showRejectButton?: boolean
  onAccept?: (box: AnnotationDataBoundingBox) => void
  onReject?: (box: AnnotationDataBoundingBox) => void
  onSelect?: (box: AnnotationDataBoundingBox) => void
  hoveredBoxIndex?: number
  onHover?: (index: number | undefined) => void
  selectionMode?: boolean
  selectedIndices?: number[]
  onToggleSelect?: (index: number) => void
  rotateLongSideVertical?: boolean
}

const AALReviewSnippetGrid: React.FC<AALReviewSnippetGridProps> = ({
  items,
  contentId,
  selectedBBoxClassIndex,
  showConfidence = true,
  showAcceptButton = false,
  showRejectButton = false,
  onAccept,
  onReject,
  onSelect,
  hoveredBoxIndex,
  onHover,
  selectionMode = false,
  selectedIndices = [],
  onToggleSelect,
  rotateLongSideVertical = false,
}) => {
  if (items.length === 0) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100">
        <div className="text-center text-muted">
          <p className="mb-0">No items to display</p>
        </div>
      </div>
    )
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gridAutoRows: 'max-content',
        gap: '12px',
        padding: '8px',
        overflowY: 'auto',
        height: '100%',
        alignItems: 'start',
      }}
    >
      {items.map((box, index) => {
        const isSelected = selectionMode
          ? selectedIndices.includes(index)
          : selectedBBoxClassIndex === box.class_index

        return (
          <div key={box.class_index} style={{ position: 'relative' }}>
            {/* Selection checkbox in bulk mode */}
            {selectionMode && (
              <div
                style={{
                  position: 'absolute',
                  top: '8px',
                  left: '8px',
                  zIndex: 10,
                }}
              >
                <Form.Check
                  type="checkbox"
                  checked={selectedIndices.includes(index)}
                  onChange={() => onToggleSelect?.(index)}
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    transform: 'scale(1.2)',
                    cursor: 'pointer',
                  }}
                />
              </div>
            )}

            <AALReviewSnippetCard
              contentId={contentId}
              bbox={box}
              isSelected={isSelected}
              showConfidence={showConfidence}
              showAcceptButton={showAcceptButton}
              showRejectButton={showRejectButton}
              onAccept={() => onAccept?.(box)}
              onReject={() => onReject?.(box)}
              onClick={() => (selectionMode ? onToggleSelect?.(index) : onSelect?.(box))}
              onHover={() => onHover?.(box.class_index)}
              onHoverEnd={() => onHover?.(undefined)}
              rotateLongSideVertical={rotateLongSideVertical}
            />
          </div>
        )
      })}
    </div>
  )
}

export default AALReviewSnippetGrid
